import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../magpiie-client/client';

export const setUnreadCount = createAction<number>(
  'notifications/setUnreadCount'
);
export const clearNotifications = createAction('notifications/clear');

export const fetchNotifications = createAsyncThunk(
  'notifications/fetchNotifications',
  async (
    params: {
      orgId?: number;
      unreadOnly?: boolean;
      page?: number;
      draftId?: number;
    },
    { rejectWithValue }
  ) => {
    const { data, error } = await apiClient.GET('/v2/notifications', {
      params: {
        query: {
          orgId: params.orgId,
          unreadOnly: params.unreadOnly,
          draftId: params.draftId,
          page: params.page ?? 1,
          limit: 20,
        },
      },
    });
    if (error) {
      return rejectWithValue('Failed to fetch notifications');
    }
    return data;
  }
);

export const fetchUnreadCount = createAsyncThunk(
  'notifications/fetchUnreadCount',
  async (orgId: number | undefined, { rejectWithValue }) => {
    const { data, error } = await apiClient.GET(
      '/v2/notifications/unread-count',
      {
        params: { query: { orgId } },
      }
    );
    if (error) {
      return rejectWithValue('Failed to fetch unread count');
    }
    return (data as { count: number }).count;
  }
);

export const markAsRead = createAsyncThunk(
  'notifications/markAsRead',
  async (id: number, { rejectWithValue }) => {
    const { error } = await apiClient.PATCH('/v2/notifications/{id}/read', {
      params: { path: { id } },
    });
    if (error) {
      return rejectWithValue('Failed to mark notification as read');
    }
    return id;
  }
);

export const markAllAsRead = createAsyncThunk(
  'notifications/markAllAsRead',
  async (orgId: number | undefined, { rejectWithValue }) => {
    const { error } = await apiClient.PATCH('/v2/notifications/read-all', {
      params: { query: { orgId } },
    });
    if (error) {
      return rejectWithValue('Failed to mark all as read');
    }
    return orgId;
  }
);

export const deleteNotification = createAsyncThunk(
  'notifications/deleteNotification',
  async (id: number, { rejectWithValue }) => {
    const { error } = await apiClient.DELETE('/v2/notifications/{id}', {
      params: { path: { id } },
    });
    if (error) {
      return rejectWithValue('Failed to delete notification');
    }
    return id;
  }
);
